import { Component, OnDestroy, inject, ChangeDetectionStrategy } from "@angular/core";
import { Observable } from "rxjs";
import { first, map } from "rxjs/operators";

import {
  AppModules,
  LorenPrivilegeEntityType,
  LorenPrivilegeEntityTypeTranslations,
  LorenRoleFormViewModel,
} from "../../loren-roles/interfaces/loren-role.interface";
import { LorenDetailsOutletService } from "../../../shared/services/loren-details-outlet-service/loren-details-outlet.service";
import { LorenRoleService } from "../../loren-roles/services/loren-role.service";
import { LorenSnackBarService } from "../../../shared/services/loren-snack-bar-service/loren-snack-bar.service";
import {
  transformDtoToFormModel,
  transformFormModelToDto,
} from "../../loren-roles/utilities/loren-role-form-trasformation-utility";
import { LorenBaseFeature } from "../../../shared/base-components/loren-base-feature/loren-base-feature";

@Component({
    selector: "loren-role-form",
    templateUrl: "./loren-role-form.component.html",
    styleUrls: ["./loren-role-form.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenRoleFormComponent
  extends LorenBaseFeature
  implements OnDestroy
{
  private lorenDetailsOutletService = inject(LorenDetailsOutletService);
  private lorenSnackBarService = inject(LorenSnackBarService);
  private lorenUserRoleService = inject(LorenRoleService);

  role$: Observable<LorenRoleFormViewModel> =
    this.lorenUserRoleService.selectedRole$.pipe(
      map((x) => {
        if (!x) {
          const newRole: LorenRoleFormViewModel = {
            id: null,
            name: "",
            readonly: false,
            entityPrivileges: [
              {
                entity: AppModules.ASSET,
                access: "READ_WRITE",
              },
              {
                entity: AppModules.ROLE,
                access: "READ_WRITE",
              },
              {
                entity: AppModules.AUTOMATION_RULES,
                access: "READ_WRITE",
              },
              {
                entity: AppModules.GROUPS,
                access: "READ_WRITE",
              },
              {
                entity: AppModules.GEOFENCE_ZONES,
                access: "READ_WRITE",
              },
            ],
          };

          return newRole;
        }

        return transformDtoToFormModel(x);
      })
    );

  translations = LorenPrivilegeEntityTypeTranslations;
  privileges = LorenPrivilegeEntityType;

  ngOnDestroy(): void {
    this.handleBackClick();
  }

  handleBackClick() {
    this.lorenDetailsOutletService.toggleState(false);
    this.lorenUserRoleService.clearSelectedRoles();
  }

  saveRole(model: LorenRoleFormViewModel) {
    if (!model.name) {
      return;
    }

    const role = transformFormModelToDto(model);
    if (role.id === null) {
      this.lorenUserRoleService
        .createRole$(role)
        .pipe(first())
        .subscribe({
          next: () => {
            this.handleBackClick();
            this.lorenSnackBarService.showSuccessMessage();
          },
        });
    } else {
      this.lorenUserRoleService
        .updateRole$(role)
        .pipe(first())
        .subscribe({
          next: () => {
            this.handleBackClick();
            this.lorenSnackBarService.showSuccessMessage();
          },
        });
    }
  }

  delete(role: LorenRoleFormViewModel) {
    this.lorenUserRoleService
      .deleteRole$(role.id)
      .pipe(first())
      .subscribe({
        next: () => {
          this.handleBackClick();
          this.lorenSnackBarService.showSuccessMessage();
        },
        error: (e) => {
          this.lorenSnackBarService.showErrorMessage(e.error.message);
        },
      });
  }
}
